import { Leaf, Shuffle, GlassWater, Gem, Sunrise, Heart, Users, KeyRound } from "lucide-react";
import { Reveal, ChapterHead } from "./Reveal";

const ITEMS = [
  ["Holistique & épicurienne", "Le wellness qui prend en compte la personne dans son ensemble.", Leaf],
  ["Hybride", "De l'atelier d'une heure à la retraite d'une semaine.", Shuffle],
  ["Consciente", "Sobre ou low alcohol, des environnements intentionnels.", GlassWater],
  ["Sélectionnée & sélective", "Immersion esthétique, exigence qualitative.", Gem],
  ["Transformatrice", "Orientée développement personnel.", Sunrise],
  ["Porteuse de sens", "Des sujets concrets : business, écologie, relations.", Heart],
  ["Collective", "Ancrée dans la communauté et le lien humain.", Users],
  ["Exclusive", "Confidentielle, sur adhésion, orientée communauté.", KeyRound],
];

export default function Vision() {
  return (
    <section
      id="vision"
      data-testid="section-vision"
      className="relative py-28 md:py-36 overflow-hidden text-[#FFF6EE]"
      style={{ background: "linear-gradient(155deg, #FF8E53 0%, #E8431F 45%, #D6478E 100%)" }}
    >
      <div className="orb w-[560px] h-[560px] bg-[#FFB347] blur-[150px] opacity-40 -top-40 right-[-10%]" aria-hidden="true" />
      <div className="orb w-[420px] h-[420px] bg-[#FF2A7A] blur-[130px] opacity-35 bottom-[-10%] left-[-8%]" aria-hidden="true" />

      <div className="wrap relative">
        <ChapterHead
          num="05"
          badge="Notre vision du wellness"
          dark
          title="Le public attend des expériences plus larges, plus hybrides."
          note="Voilà ce qu'on construit : huit convictions qui guident chacune de nos productions."
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          {ITEMS.map(([title, desc, Icon], i) => (
            <Reveal key={title} delay={(i % 4) * 0.06}>
              <div
                data-testid={`vision-item-${i + 1}`}
                className="h-full rounded-[24px] bg-white/30 backdrop-blur-xl border border-white/40 p-8 md:p-9 transition-colors duration-500 hover:bg-white/45"
              >
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-white/40 text-[#8E2F1C]">
                  <Icon size={17} strokeWidth={1.8} />
                </span>
                <h3 className="font-serifit italic text-2xl mt-4 mb-3 leading-snug text-[#33181F]">{title}</h3>
                <p className="text-[0.88rem] text-[#33181F]/70 font-medium leading-relaxed">{desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
